export const mrCode = 14000120

export const colors = {
    primary: '#3c68c3',
    secondary: '#2a304e',
    tertiary: '#232840'
}